import axios from "axios"
import {getConfig} from "./utility";

const initialState = {
    customers: [],
    fetchingCustomers: false,
    creatingCustomer: false,
    updatingCustomer: false,
};

const CUSTOMERS_FETCH = "CUSTOMER_FETCH";
const SEARCH = "CUSTOMER_SEARCH";
const CUSTOMER_CREATE = "CUSTOMER_CREATE";
const CUSTOMER_UPDATE= "CUSTOMER_UPDATE";

export default (state = initialState, action) => {
    switch (action.type) {
        case CUSTOMERS_FETCH:
            switch (action.status) {
                case 0:
                    return {...state, fetchingCustomers: true};
                case 1:
                    return {...state, customers: action.customers, fetchingCustomers: false};
                default:
                    return {...state, fetchingCustomers: false}
            }
        case SEARCH:
            switch (action.status) {
                case 0:
                    return {...state, fetchingCustomers: true};
                case 1:
                    return {...state, customers: action.customers, fetchingCustomers: false};
                default:
                    return {...state, fetchingCustomers: false};
            }
        case CUSTOMER_CREATE:
            switch (action.status) {
                case 0:
                    return {...state, creatingCustomer: true};
                case 1:
                    return {...state, customers: action.customers, creatingCustomer: false};
                default:
                    return {...state, creatingCustomer: false};
            }
        case CUSTOMER_UPDATE:
            switch (action.status) {
                case 0:
                    return {...state, updatingCustomer: true};
                case 1:
                    return {...state, customers: action.customers, updatingCustomer: false};
                default:
                    return {...state, updatingCustomer: false};
            }
        default:
            return state
    }
}

const getCustomersReq = () => ({type: CUSTOMERS_FETCH, status: 0});
const getCustomersSuc = customers => ({type: CUSTOMERS_FETCH, status: 1, customers});
const getCustomersErr = error => ({type: CUSTOMERS_FETCH, status: -1, error});
export const getCustomers = () => (dispatch, getState) => {
    dispatch(getCustomersReq());
    return axios.get('/customer', getConfig(getState))
        .then(res => dispatch(getCustomersSuc(res.data)))
        .catch(err => dispatch(getCustomersErr(err)))
};

const searchReq = request => ({type: SEARCH, status: 0, request});
const searchSuc = customers => ({type: SEARCH, status: 1, customers});
const searchErr = error => ({type: SEARCH, status: -1, error});
export const search = (request) => (dispatch, getState) => {
    dispatch(searchReq(request));
    return axios.post('/customer/search', request, getConfig(getState))
        .then(res => dispatch(searchSuc(res.data)))
        .catch(err => dispatch(searchErr(err)))
}

const createCustomerReq = (request) => ({type: CUSTOMER_CREATE, status: 0, request});
const createCustomerSuc = customers => ({type: CUSTOMER_CREATE, status: 1, customers});
const createCustomerErr = error => ({type: CUSTOMER_CREATE, status: -1, error});
export const createCustomer = (request) => (dispatch, getState) => {
    dispatch(createCustomerReq(request));
    return axios.post('/customer/createCustomer', request, getConfig(getState))
        .then(res => dispatch(createCustomerSuc(res.data)))
        .catch(err => dispatch(createCustomerErr(err)))
}

const updateCustomerReq = (request) => ({type: CUSTOMER_UPDATE, status: 0, request});
const updateCustomerSuc = customers => ({type: CUSTOMER_UPDATE, status: 1, customers});
const updateCustomerErr = error => ({type: CUSTOMER_UPDATE, status: -1, error});
export const updateCustomer = (request) => (dispatch, getState) => {
    dispatch(updateCustomerReq(request));
    return axios.post('/customer/updateCustomer', request, getConfig(getState))
        .then(res => dispatch(updateCustomerSuc(res.data)))
        .catch(err => dispatch(updateCustomerErr(err)))
}


// WEBPACK FOOTER //
// ./src/js/reducers/customer.js